<template>
  <div class="selector-overlay"></div>
</template>

<script>
export default {
  
}
</script>

<style lang="scss" scoped>

.selector-overlay {
  position: absolute;
  top: 0;
  left: 0;
  background: $mainGreen;
  box-shadow: 0px 2px 12px rgba(73, 125, 56, 0.5);
  border-radius: 5px;
  z-index: -1;

  transition: 
    transform 0.5s ease, 
    width 0.5s ease, 
    opacity 0.5s ease, 
    height 0.5s ease;
}

</style>